import { useEffect, useState } from "react";
import { bTh, getTotal, getValue, mTh } from "../../../../../helpers/functions/report-table";
import "./dashboard-st-table.css";

export default function ServerDomains({ data, getReqPerSec }) {
  const [sortedData, setSortedData] = useState();

  useEffect(() => {
    sort_obj_keys();
  }, [data]);

  const sort_obj_keys = () => {
    let allKeys = Object.keys(data);
    allKeys.sort();
    let temp_obj = {};
    for (let i = 0; i < allKeys.length; i++) {
      const key = allKeys[i];
      if (key === "*") {
        temp_obj["all"] = data[allKeys[i]];
      } else if (key === "_") {
        continue;
      }
      else {
        temp_obj[key] = data[key];
      }
    }

    setSortedData(temp_obj);
  }

  return (
    <>
      {sortedData &&
        <>
          <h6 className="table-title pb-2">Server Domains:</h6>

          <div className="report-table-container">
            <table>
              <thead>
              <tr>
                <th rowSpan="2" className="td-sticky">Domain</th>
                <th colSpan="3">Requests</th>
                <th colSpan="6">Responses</th>
                <th colSpan="4">Traffic</th>
                <th colSpan="9">Cache</th>
              </tr>
              <tr>
                <th>Total</th>
                <th>Req/s</th>
                <th>Time</th>
                <th>1xx</th>
                <th>2xx</th>
                <th>3xx</th>
                <th>4xx</th>
                <th>5xx</th>
                <th>Total</th>
                <th>Sent</th>
                <th>Rcvd</th>
                <th>Sent/s</th>
                <th>Rcvd/s</th>
                <th>Miss</th>
                <th>Bypass</th>
                <th>Expired</th>
                <th>Stale</th>
                <th>Updating</th>
                <th>Revalidated</th>
                <th>Hit</th>
                <th>Scarce</th>
                <th>Total</th>
              </tr>
              </thead>
              <tbody>
              {Object.keys(sortedData).map((k, i) => {
                let obj = sortedData[k];
                const responses = {
                  "1xx": getValue(obj, "1xx"),
                  "2xx": getValue(obj, "2xx"),
                  "3xx": getValue(obj, "3xx"),
                  "4xx": getValue(obj, "4xx"),
                  "5xx": getValue(obj, "5xx")
                }
                const caches = {
                  "miss": getValue(obj, "miss"),
                  "bypass": getValue(obj, "bypass"),
                  "expired": getValue(obj, "expired"),
                  "stale": getValue(obj, "stale"),
                  "updating": getValue(obj, "updating"),
                  "revalidated": getValue(obj, "revalidated"),
                  "hit": getValue(obj, "hit"),
                  "scarce": getValue(obj, "scarce")
                }

                return (
                  <tr key={i}>
                    <th className="td-sticky">{k}</th>
                    <td>{obj.requestCounter + obj.overCounts["maxIntegerSize"] * obj.overCounts["requestCounter"]}</td>
                    <td>{getReqPerSec(`server-domain-req-${k}`, obj.requestCounter)}</td>
                    <td>{mTh(obj.requestMsec)}</td>
                    <td>{responses["1xx"]}</td>
                    <td>{responses["2xx"]}</td>
                    <td>{responses["3xx"]}</td>
                    <td>{responses["4xx"]}</td>
                    <td>{responses["5xx"]}</td>
                    <td>{getTotal(responses)}</td>
                    <td>{bTh(obj.outBytes + obj.overCounts["maxIntegerSize"] * obj.overCounts["outBytes"])}</td>
                    <td>{bTh(obj.inBytes + obj.overCounts["maxIntegerSize"] * obj.overCounts["inBytes"])}</td>
                    <td>{bTh(getReqPerSec(`server-domain-ts-${k}`, obj.outBytes))}</td>
                    <td>{bTh(getReqPerSec(`server-domain-tr-${k}`, obj.inBytes))}</td>
                    <td>{caches["miss"]}</td>
                    <td>{caches["bypass"]}</td>
                    <td>{caches["expired"]}</td>
                    <td>{caches["stale"]}</td>
                    <td>{caches["updating"]}</td>
                    <td>{caches["revalidated"]}</td>
                    <td>{caches["hit"]}</td>
                    <td>{caches["scarce"]}</td>
                    <td>{getTotal(caches)}</td>
                  </tr>
                )
              })}
              </tbody>
            </table>
          </div>
        </>
      }
    </>
  )
}
